import axios from 'axios';
import { API_BASE_URL } from '../config';
import { firebase_api } from './firebase-api';

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
}

export function createAxios(default_url = API_BASE_URL) {
  const axiosObj = axios.create();

  axiosObj.interceptors.request.use(
    async config => {
      config.baseURL = default_url;
      const token = window.localStorage.getItem("api-token");

      if (token) {
        config.headers = {
          'x-firebase-idtoken': token,
          Accept: 'application/json',
          'Accept-Language': 'vi',
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          ...(config.headers || {}),
        };
      }

      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  axiosObj.interceptors.response.use(
    response => {
      if (response && response.data) {
        return response.data;
      }
      return response;
    },
    async error => {
      const status = error?.status || error?.response?.status;
      const originalRequest = error.config;

      if (status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
          return new Promise(function (resolve, reject) {
            failedQueue.push({ resolve, reject });
          }).then(firebase_response => {
            originalRequest.headers['x-firebase-idtoken'] = firebase_response.idToken;
            return axios(originalRequest).then(res => res?.data ? res.data : res);
          }).catch(err => {
            return Promise.reject(err);
          });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        return new Promise(function (resolve, reject) {
          const refreshToken = window.localStorage.getItem("api-refresh-token");
          
          if (!refreshToken) {
            processQueue(new Error('No refresh token'), null);
            isRefreshing = false;
            window.location.href = '/auth';
            reject(new Error('No refresh token'));
            return;
          }

          firebase_api.refreshToken(refreshToken)
            .then((firebase_response) => {
              let token = firebase_response.idToken;

              window.localStorage.setItem("api-token", token);
              window.localStorage.setItem("api-refresh-token", firebase_response.refreshToken);

              axiosObj.defaults.headers.common['x-firebase-idtoken'] = token;
              originalRequest.headers['x-firebase-idtoken'] = token;
              processQueue(null, token);

              resolve(axios(originalRequest).then(res => res?.data ? res.data : res));
            })
            .catch(err => {
              processQueue(err, null);
              window.localStorage.removeItem("api-token");
              window.localStorage.removeItem("api-refresh-token");
              window.location.href = '/auth';
              reject(err);
            })
            .finally(() => {
              isRefreshing = false;
            });
        });
      }

      return Promise.reject(error);
    }
  );

  return axiosObj;
}

export const axiosClient = createAxios();


